import firebase from 'firebase';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCot_fIF_Q5f4cev2cfuMsyGh2Nu65QLzM",
    authDomain: "milagrosrodriguezc-f1cf3.firebaseapp.com",
    databaseURL: "https://milagrosrodriguezc-f1cf3.firebaseio.com",
    projectId: "milagrosrodriguezc-f1cf3",
    storageBucket: "milagrosrodriguezc-f1cf3.appspot.com",
    messagingSenderId: "660558862424"
};
firebase.initializeApp(config);

export default firebase;

export const database = firebase.database();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();


// WEBPACK FOOTER //
// ./src/actions/firebase.js